// extracted by mini-css-extract-plugin
export default {"join_us":"Footer_join_us__0OzAP","title":"Footer_title__1HvLZ","text":"Footer_text__T4KHv"};